export const oxxioImageTokens = {
  imageSplitviewBorderRadii: '0',
};
